import { useQuery } from 'react-query'

import { getLatestTanningCheckIn } from '_services/check-in/check-in.service'
import useSiteStore from '_stores/site.store'

export const useGetLatestTanningCheckIn = (clientId) => {
  const siteId = useSiteStore((state) => state.currentSite?.siteId)

  return useQuery(
    [getLatestTanningCheckIn.key, { clientId, siteId }],
    getLatestTanningCheckIn.query,
    {
      enabled: !!(clientId && siteId),
    }
  )
}
